import { React } from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

function CourseLandingPageInstructorCard({ instructor, reversed, resourceURL, title }) {

  const { instructorName, instructorBiography, instructorImageURL } = instructor;

  return (
    <div className={`CourseLandingPage-instructor-card ${reversed ? "reversed" : ""}`}>
      <div className="container-image">
        <img src={instructorImageURL} alt={instructorName} />
      </div>
      <div className="container-info">
        <div className="container-heading">
          <h2>{instructorName}</h2>
          <hr />
        </div>
        <div className="bio" dangerouslySetInnerHTML={{ __html: instructorBiography }} />
        { title && title !== "Rediscovering Advent" &&
          <Button 
            variant="outlined"
            onClick={() => window.open(resourceURL, "_blank")}
          >
            View Syllabus
          </Button>
        }
      </div>
    </div>
  )
}

CourseLandingPageInstructorCard.propTypes = {
  instructor: PropTypes.object,
  reversed: PropTypes.bool,
  resourceURL: PropTypes.string,
  title: PropTypes.string
};

export default CourseLandingPageInstructorCard;